// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LK","addressTitle":"MK","link":"NK","endingInRow":"OK","expired":"PK"};